module.exports = __webpack_public_path__ + "img/banner-1-m.702901fb.jpg";